module.exports = __webpack_public_path__ + "e1ce95e62cda8cbf4cf91cd8e14c6afd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snd/fail.mp3
// module id = 515
// module chunks = 0